export default {
  errorsRootKey: 'ctis',
  resource: 'ctis',
  actions: ['index']
}
